var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function HouseQuestionIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M81.001 79h-34v46h34V79z",
      fill: "#009CEB",
      stroke: "#009CEB",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M106.874 47.87h-85.36a2 2 0 00-2 2v73.083a2 2 0 002 2h85.36a2 2 0 002-2V49.869a2 2 0 00-2-2zM65.4 4.246a2 2 0 00-2.507 0L13.088 44.31c-1.47 1.184-.634 3.559 1.254 3.559h99.609c1.887 0 2.724-2.375 1.253-3.559L65.4 4.246z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M61.51 115.17h3.42v-4.56h-3.42v4.56zm-2.85-21.09c.19-1.71 1.33-3.8 5.13-3.8 3.99 0 5.13 2.85 5.13 4.56 0 5.32-7.03 5.13-7.03 12.35h2.66c0-6.27 7.03-5.7 7.03-12.35 0-3.61-2.66-6.84-7.79-6.84-4.56 0-7.6 2.47-7.79 6.08h2.66z",
      fill: "#fff"
    })))
  }));
}

export default HouseQuestionIllustration;